import { render } from "./GalerieSegment.vue?vue&type=template&id=3cc01e66"
import script from "./GalerieSegment.vue?vue&type=script&lang=js"
export * from "./GalerieSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__